import Translation from '@/client/components/Translation';

type Props = {
  translations: Record<string, string>;
};

const Header: FC<Props> = ({ translations }) => (
  <div className="grid grid-flow-col gap-4">
    <h5 className="text-moon-18 font-medium text-bulma">
      <Translation
        translations={translations}
        id="game-leaderboards.leaderboard"
      />
    </h5>
  </div>
);

export default Header;
